    <template>
    <div id="adminlogin">
        <div class="container-fluid">
            <Alert v-bind:message='error'   type="alert-danger" v-if="error"/>
            <div class="row">
                    <div class="col-12 text-center my-5 ">
                        <img height="50" src="../assets/tribeid.png" alt="">
                    </div>
                </div>
            <div class="row justify-content-center align-items-">
                <div class="col-lg-5 col-md-8 col-sm-12">
                    <div class="card">
                        <div class="card-header">
                            <h2 class="text-center">Sign in to TribeId</h2>
                        </div>
                        <div class="card-body">
                            <form class="" @submit.prevent="login">
                            <div class="form-group mb-2">
                                <label for="staticEmail2" class="form-label">Email</label>
                                <input type="email" class="form-control" id="staticEmail2"  placeholder="me@example.com" v-model.trim="email" required>
                                <p class="emailError" v-if="emailError">{{emailError}}</p>
                            </div>
                            <div class="form-group mb-2">
                                <label for="inputPassword2" class="form-label">Password</label>
                                <input type="password" class="form-control" id="inputPassword2"  placeholder="Password" v-model.trim="password" required>
                                <p class="passwordError" v-if="passwordError">{{passwordError}}</p>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <p class="text-center my-4">By signing in, I agree to the <a href="">Terms </a> and <a href="">Privacy Policy </a>.</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <button type="submit" class="btn my-2 btn-lg">
                                        Sign In
                                    </button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 text-center py-3 bottom-links">
                                    <a  href="" data-toggle="modal" data-target="#resetPassword">Forgot Your Password?</a> <br>
                                    <a href="/accounts/signup/">Create An Account</a>
                                </div>
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Start of Forgot password modal -->
        <div class="modal fade" id="resetPassword" tabindex="-1" aria-labelledby="reset password" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLabel">Forgot your password?</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <Alert v-bind:message='success' type='alert-success' v-if="success"/>
              <Alert v-bind:message="addError" type="alert-danger" v-if="addError" />
              <div class="row">
                  <div class="col-12">
                      <div class="alert alert-secondary" role="alert">
                        <small>
                            Please enter your email address below and we will send you instructions for resetting your password. 
                            <strong>Note that the link will expire in 24 hours</strong></small>
                      </div>
                  </div>
              </div>
              <form @submit.prevent="addMarket">
                  <div class="form-group">
                    <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="me@example.com" v-model="marketName" required>
                  </div>
                  <div class="form-group">
                      <button type="submit" class="btn btn-danger my-4" style="float:right">reset password</button>
                  </div>
              </form>
            </div>
          </div>
        </div>
      </div>
        <!-- End of Forgot password modal -->
    </div>
</template>

<script>
import Alert from '../components/Alert'

export default {
    components: {
        Alert:Alert
    },
    data(){
        return {
            email:'',
            password:'',
            error:'',
            loading:false,
            passwordError:null,
            emailError:null,
        }
    },
    methods: {
        login() {
            this.loading = true
            this.error = ''
            const data = {
                email:this.email,
                password:this.password
            }
        //     this.$store.dispatch('adminLogin',data)
        //         .then( (data) => {  
        //             this.loading = false
        //             this.$router.push('/admin')  
        //             })
        //         .catch( (err) => {
        //             if(err?.response?.data === undefined) {
        //                 this.loading = false;
        //                 this.error = 'Network error!.Try again.'
        //             }
        //         })
        //    }
        if(!this.email) {
            this.emailError = 'email address is required.'
            return
        } 
        if(!this.password) {
            this.passwordError = 'password is required.'
            return
        }

        if(this.email && this.password) {
            alert('login')
        }

         }
    },

}
</script>

<style scoped>
    #adminlogin{
        background-image:url('../assets/hero.jpg');
        width:100%;
        background-position: center;
        background-attachment: fixed;
        background-repeat: no-repeat;
        height: 100vh;
    }
    a:hover{
        color:black
    }
    h2{
        color:black;
        font-weight: 500;
        font-size: 1.5em;
    }
    input{
        color:#ba2428
    }
    :placeholder-shown{
        color:#ba2428!important;
    }
    a{
        color:#ba2428
    }
    .btn{
        width:100%;
        background-color:#ba2428;
        color:rgb(214, 208, 208);
    }
    .passwordError,.emailError{
        font-size: .9em;
        color:#ba2428
    }
</style>    